import { useEffect } from 'react'

type Props = {
  message: string
  tone?: 'success' | 'info'
  onDismiss: () => void
}

export function Toast({ message, tone = 'success', onDismiss }: Props) {
  useEffect(() => {
    const timer = window.setTimeout(onDismiss, 4000)
    return () => window.clearTimeout(timer)
  }, [message, onDismiss])

  return (
    <div
      role="status"
      className={`toast toast-${tone}`}
      aria-live="polite"
    >
      <span className="material-symbols-outlined text-xl shrink-0">
        {tone === 'success' ? 'check_circle' : 'info'}
      </span>
      <p className="text-body-sm font-medium flex-1">{message}</p>
      <button
        type="button"
        onClick={onDismiss}
        className="text-inherit opacity-70 hover:opacity-100"
        aria-label="Tutup notifikasi"
      >
        <span className="material-symbols-outlined text-lg">close</span>
      </button>
    </div>
  )
}
